/* Toate culorile se schimba cu complementarul lor in light theme */

const lightTheme = {
  palette: {
    type: 'light',
    background: {
      default: '#EEF0F2',
    },
    clrAccent: '#FFFFFF',
    clrHover: {
      main: '#1976d2',
    },
    clrReddit: '#ff4500',
  },
};

export default lightTheme;
